export default __webpack_public_path__ + "static/media/5.2bc99ba7.png";